import { handleExpiredTokens } from 'api/apiReqSagaCreator/httpRequest';
import { OdataURLBuilder } from 'api/types/OdataURLBuilder';
import {
  ApiResponseAsync,
  translateAxiosErrorToApiError,
} from 'container/models';

import BaseRepo from '../../BaseRepo';
import { ISystemLogsRepo, Status, SystemLogGeneral } from './ISystemLogsRepo';

export class SystemLogsRepo extends BaseRepo implements ISystemLogsRepo {
  getLogs = (
    request: OdataURLBuilder
  ): ApiResponseAsync<SystemLogGeneral[] | number> =>
    handleExpiredTokens(() =>
      this.client.get<SystemLogGeneral[] | number>(request.toString())
    )
      .then((response) => response.data)
      .catch(translateAxiosErrorToApiError);

  getStatus = (releaseOrDraftProcessId: string): ApiResponseAsync<Status> =>
    handleExpiredTokens(() =>
      this.client.get<Status>(
        `/processes/${releaseOrDraftProcessId}/service-status`
      )
    )
      .then((response) => {
        const data = response.data;

        for (const value of Object.values(data)) {
          if ('lastSuccessDate' in value) {
            value.lastSuccessDate = new Date(value.lastSuccessDate);
          }
          if ('lastFailDate' in value) {
            value.lastFailDate = new Date(value.lastFailDate);
          }
          if ('scheduledTime' in value) {
            value.scheduledTime = new Date(value.scheduledTime);
          }
        }

        return data;
      })
      .catch(translateAxiosErrorToApiError);
}
